import supabase from '../supabase/supabase';

const progressFields = [
  'id',
  'enrollment_id',
  'learning_unit_id',
  'course_version_id',
  'status',
  'started_at',
  'completed_at',
  'last_accessed_at',
  'created_at',
  'updated_at'
].join(', ');

function throwIfError(error) {
  if (error) throw error;
}

export async function getCourseLearningUnitIdentities(courseVersionId) {
  const { data, error } = await supabase
    .from('hms_academy_learning_units_1715725000000')
    .select('id, unit_key')
    .eq('course_version_id', courseVersionId);

  throwIfError(error);
  return data || [];
}

export async function getEnrollmentUnitProgress({ enrollmentId, courseVersionId }) {
  const { data, error } = await supabase
    .from('hms_academy_unit_progress_1715727000000')
    .select(progressFields)
    .eq('enrollment_id', enrollmentId)
    .eq('course_version_id', courseVersionId);

  throwIfError(error);
  return data || [];
}

export async function completeLearningUnit({
  enrollmentId,
  courseVersionId,
  learningUnitId
}) {
  const { data: existingProgress, error: readError } = await supabase
    .from('hms_academy_unit_progress_1715727000000')
    .select(progressFields)
    .eq('enrollment_id', enrollmentId)
    .eq('course_version_id', courseVersionId)
    .eq('learning_unit_id', learningUnitId)
    .maybeSingle();

  throwIfError(readError);

  if (existingProgress?.status === 'completed') {
    return existingProgress;
  }

  const { data, error } = await supabase
    .from('hms_academy_unit_progress_1715727000000')
    .upsert(
      {
        enrollment_id: enrollmentId,
        learning_unit_id: learningUnitId,
        course_version_id: courseVersionId,
        status: 'completed'
      },
      { onConflict: 'enrollment_id,learning_unit_id' }
    )
    .select(progressFields)
    .single();

  throwIfError(error);
  return data;
}